import { getAppLogoUrl } from '@/constants/appIcons';

interface AppLogoProps {
  shortName: string;
  displayName: string;
  size?: 'sm' | 'md';
}

/**
 * Renders either the brand logo for the app, or a coloured initial-letter fallback.
 * Callers sometimes derive the names from LLM-emitted content, so missing values
 * degrade to a "?" avatar instead of crashing the surrounding card.
 */
export function AppLogo({ shortName, displayName, size = 'md' }: AppLogoProps) {
  const logoUrl = getAppLogoUrl(shortName);
  const dimension = size === 'md' ? 'w-7 h-7' : 'w-5 h-5';
  const textSize = size === 'md' ? 'text-sm' : 'text-xs';

  if (logoUrl) {
    return <img src={logoUrl} alt={displayName || shortName} className={`${dimension} object-contain`} />;
  }

  return (
    <div className={`${dimension} rounded bg-custom-sidebar-active flex items-center justify-center`}>
      <span className={`${textSize} font-semibold text-custom-text-primary`}>
        {(displayName || shortName || '?').charAt(0).toUpperCase()}
      </span>
    </div>
  );
}
